import { MAIN, ROOT_URL } from "../../../routes/constants";
import BPOrder from "./BPOrder";
import OrderShops from "../BPOrderShops/OrderShops"; 
import OrderItems from "../BPOrderItems/OrderItems"; 
import OrderUpload from "../BPOrderUpload/OrderUpload"; 
import OrderUploadDetails from "../BPOrderUpload/OrderUploadDetails";
//Module Page Routes
export const ORDER = MAIN + "/Order";
export const ORDER_SHOPS = ORDER + "/shops";
export const ORDER_ITEMS = ORDER + "/items";
export const ORDER_UPLOAD = ORDER+ "/upload";
export const ORDER_UPLOAD_DETAILS = ORDER+ "/upload/:historyNo?";

const BpOrderRoutes = [
    {
        label: "ORDER",
        path: [ORDER,ROOT_URL],
        component: BPOrder,
        exact: true,
        mainscreen: true
    },
    {
        label: "ORDER_SHOPS",
        path: ORDER_SHOPS,
        component: OrderShops,
        exact: true,
    },
    {
        label: "ORDER_ITEMS",
        path: ORDER_ITEMS,
        component: OrderItems,
        exact: true,
    },
    {
        label: "ORDER_UPLOAD",
        path: ORDER_UPLOAD,
        component: OrderUpload,
        exact: true
    },
    {
        label: "ORDER_UPLOAD_DETAILS",
        path: ORDER_UPLOAD_DETAILS,
        component: OrderUploadDetails,
        exact: true
    }
];

export default BpOrderRoutes;